<template >
  <header>
    <!-- sidebar -->
    <customer-sidebar ref="sidebar">
      <div class="sidebar-header">
        <h3>{{$store.state.account.name}}</h3>
      </div>
      <ul class="list-unstyled sidebar-content">
        <li v-show="WITH_ADMIN_ROLE">
          <a
            href="#"
            @click="goPath('/console')"
          >控制台</a>
        </li>
        <li v-show="WITH_RESTAURANT_ROLE">
          <a
            href="#"
            @click="goPath('/shop')"
          >後台</a>
        </li>
        <li>
          <a
            href="#"
            @click="goPath('/customer/orders')"
          >我的訂單</a>
        </li>
        <li>
          <a
            href="#"
            @click="goPath('/customer/account')"
          >我的帳戶</a>
        </li>
        <li>
          <a
            href="#"
            @click="goPath('/customer/yumcoin')"
          >我的Yum幣</a>
        </li>
        <!-- <li>
          <a
            href="#"
            class="disabled"
          >優惠情報</a>
        </li>
        <li>
          <a
            href="#"
            class="disabled"
          >付款</a>
        </li> -->
        <li>
          <a
            href="#"
            @click="goPath('/customer/help')"
          >幫助</a>
        </li>
        <!-- <li>
                <a href="#" class="disabled">最新消息</a>
            </li> -->
        <li @click="logout">
          <a href="#">登出</a>
        </li>
      </ul>
    </customer-sidebar>
    <!-- header-->
    <div class="header-nav">
      <b-row>
        <b-col class="header-left">
          <i
            class="fas fa-align-justify clickable"
            v-if="IS_LOGIN"
            @click="openSidebar"
          ></i>
          <i
            class="fas fa-user clickable"
            v-else
            @click="showLoginHandler"
          ></i>
        </b-col>
        <b-col class="header-center">
          <b-navbar-brand
            href="#"
            class="logo"
            @click="backhome"
          >
            <img src="@/assets/images/logo_small.png">
          </b-navbar-brand>
        </b-col>
        <b-col class="header-right">
          <div
            class="order-noti"
            :class="{active:orderNotify}"
            v-if="IS_LOGIN"
          >
            <i
              class="fas fa-bell"
              @click="showNotiContent = !showNotiContent"
            ></i>
            <notification
              class="noti-tooltip"
              :ordernoti="orderNotify"
              :messages="messages"
              :show="showNotiContent"
              @route="routeToPath"
              @hide="showNotiContent=false"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <!--
    <b-nav-item-dropdown text="Lang" right disabled>
      <b-dropdown-item href="#">中文</b-dropdown-item>
    </b-nav-item-dropdown>
    -->
    <signinarea ref="signin-area" />

  </header>
</template>

<script>
import signinarea from '@/components/customer/SignInModal'
import notification from '@/components/customer/Notification'
import customerSidebar from '@/components/customer/Sidebar'
import { mapGetters } from 'vuex'
import { db } from '@/assets/js/firestore.js'

export default {
  name: 'customer-header',
  components: { signinarea, customerSidebar, notification },
  mounted () {
    let _vue = this
    if (_vue.IS_LOGIN) {
      _vue.setupCustomerNoti()
    }
    _vue.$eventHub.$on('setup-customer-noti', _vue.setupCustomerNoti)
    _vue.$eventHub.$on('shutdown-customer-noti', _vue.shutdownCustomerNoti)
  },
  beforeDestroy () {
    this.shutdownCustomerNoti()
    this.$eventHub.$off('setup-customer-noti')
    this.$eventHub.$off('shutdown-customer-noti')
  },
  data () {
    return {
      unsubscribe: null,
      orderNotify: false,
      showNotiContent: false,
      // data
      messages: []
    }
  },
  methods: {
    goPath (path) {
      this.routeToPath(path)
      this.closeSidebar()
    },
    logout () {
      this.$store.dispatch('account/LOGOUT')
      this.shutdownCustomerNoti()
      this.closeSidebar()
      this.routeToPath('/homepage')
    },
    backhome () {
      this.routeToPath('/homepage')
    },
    showLoginHandler: async function () {
      this.$refs['signin-area'].open()
    },
    openSidebar () {
      this.$refs.sidebar.openSidebarPanel()
    },
    closeSidebar () {
      this.$refs.sidebar.closeSidebarPanel()
    },
    setupCustomerNoti () {
      let _vue = this
      if (_vue.IS_LOGIN && _vue.USER_ID) {
        this.unsubscribe = db.collection('customer').doc(_vue.USER_ID.toString()).onSnapshot((doc) => {
          let _data = doc.data()
          if (_data) {
            this.orderNotify = _data.uncompletedOrder
            this.messages = _data.messages
          }
        })
      }
    },
    shutdownCustomerNoti () {
      if (this.unsubscribe) {
        this.unsubscribe()
      }
    },
    routeToPath (path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path)
      }
      this.showNotiContent = false
    }
  },
  computed: {
    ...mapGetters('account', [
      'USER_ID',
      'IS_LOGIN',
      'WITH_CUSTOMER_ROLE',
      'WITH_RESTAURANT_ROLE',
      'WITH_ADMIN_ROLE'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

header {
  padding: 0.5em 0.8em;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
  .header-nav {
    font-size: 1.3em;
    color: $papayum_red;
    .header-left {
      text-align: left;
    }
    .header-center {
      text-align: center;
    }
    .header-right {
      text-align: right;
    }
    .logo {
      height: 2rem;
      overflow: hidden;
      img {
        margin-top: -2em;
        height: 5em;
      }
    }
    .order-noti {
      position: relative;
      border: none;
      outline: none;
      color: $papayum_red;
      background-color: white;
      &.active::after {
        content: "!";
        position: absolute;
        bottom: -0.2rem;
        font-weight: bold;
        font-size: 1rem;
        color: $papayum_red;
      }
      // &:focus-within {
      //   .noti-tooltip {
      //     display: initial;
      //   }
      // }
      .noti-tooltip {
        // display: none;
        z-index: map-get($z-index, float);
        right: -0.15rem;
        top: 2.5rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer/Header.vue